module.exports = __webpack_public_path__ + "static/media/b48517ad.jpg";